import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { SearchField } from "../../../../components/form-controls/search-field/search-field.component";
import { withShowIf } from "../../../../components/with-show-if/with-show-If.component";
import { Nullable } from "../../../../types/common";

import * as campaignBriefStore from "../../../campaign-brief/store/campaign-brief.store";

import { CampaignBriefsSearchProps, ICampaignBriefBare } from "./campaign-briefs-search.props";
import { CampaignBriefsSearchResults } from "../campaign-briefs-search-results/campaign-briefs-search-results.components";
import { selectCampaignBriefSearchResults } from "../../../../redux/selectors/commonSelectors";

export const CampaignBriefSearch = withShowIf((props: CampaignBriefsSearchProps) => {
  const ref: MutableRefObject<Nullable<HTMLDivElement>> = useRef(null);
  const [shouldReset, setShouldReset] = useState(false);

  const searchResults = useSelector(selectCampaignBriefSearchResults) || [];
  const selectedIds = props.currentValue.map((brief) => brief.id);
  const filteredResults = searchResults.filter((brief) => !selectedIds.includes(brief.id));

  useEffect(
    () => {
      document.addEventListener("click", handlePageClick);
      return () => document.removeEventListener("click", handlePageClick);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    setShouldReset(props.reset || false);
  }, [props]);

  const handlePageClick = (e: any) => {
    if (ref.current && !ref.current?.contains(e.target)) {
      setShouldReset(true);
      reset();
    }
  };

  const handleSearch = (searchTerm: string) => {
    if (searchTerm.length) {
      campaignBriefStore.search(searchTerm);
    }
  };

  const reset = () => campaignBriefStore.clearSearchResults();

  const onSelect = (brief: ICampaignBriefBare) => {
    props.onSelect(brief);
    reset();
  };

  return (
    <div ref={ref}>
      <SearchField
        id={props.id}
        label={props.label || "search"}
        placeholder={props.placeholder || "Search"}
        size={props.size || "small"}
        isDisabled={props.isDisabled || false}
        ref={props.ref}
        resetSearch={shouldReset || Boolean(props.reset)}
        onSearch={handleSearch}
        onCancel={reset}
      />
      {props.children}
      <CampaignBriefsSearchResults briefs={filteredResults} handleSelect={onSelect} />
    </div>
  );
});
